// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__rAJPk","starIcon":"Rating_starIcon__tUSrT","starIconFilled":"Rating_starIconFilled__lxYG8"};